import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/icons/essential/10-close-big.svg'
import _imports_1 from '@/assets/icons/essential/04-chevron-down.svg'


const _hoisted_1 = { class: "meta" }
const _hoisted_2 = {
  key: 0,
  class: "catalogue-product-list--container"
}
const _hoisted_3 = {
  class: "product-list--header fade-down column",
  "data-cy": "product-list-header-fade-down"
}
const _hoisted_4 = {
  class: "product-list--header-column",
  "data-cy": "product-list-header"
}
const _hoisted_5 = { class: "meta" }
const _hoisted_6 = { class: "product-list--header-column product-query-input" }
const _hoisted_7 = { class: "product-list--header-column add-items" }
const _hoisted_8 = {
  key: 0,
  class: "product-list--header-column"
}
const _hoisted_9 = { class: "meta danger" }
const _hoisted_10 = { class: "product-list--header-column" }
const _hoisted_11 = {
  class: "meta",
  style: {"font-family":"monospace","font-size":"80%"}
}
const _hoisted_12 = {
  key: 0,
  class: "product-items--placeholder placeholder"
}
const _hoisted_13 = {
  key: 1,
  class: "product-items--list ozn-entry-list medium",
  name: "catalogue-product-list",
  tag: "div",
  "data-cy": "product-item-list"
}
const _hoisted_14 = { class: "row product-card--container" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  class: "icon active",
  "svg-inline": "",
  src: _imports_0,
  alt: "close"
}
const _hoisted_18 = {
  class: "icon",
  "svg-inline": "",
  src: _imports_1,
  alt: "expand"
}
const _hoisted_19 = {
  key: 0,
  class: "column product-card__image--container ozn-entry-item__header--left"
}
const _hoisted_20 = {
  class: "column product-card__info--container ozn-entry-item__header--right",
  style: {"max-width":"85%"}
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 1,
  class: "unlinked-notice notice inline dense fullwidth warn dark"
}
const _hoisted_23 = {
  class: "row",
  style: {"margin-top":"-7px"}
}
const _hoisted_24 = {
  class: "meta",
  style: {"line-height":"1","padding-top":"5px","opacity":".7"}
}
const _hoisted_25 = { class: "row product-card__info--container" }
const _hoisted_26 = {
  key: 0,
  class: "product-details column"
}
const _hoisted_27 = {
  class: "row",
  style: {"padding":"10px 0 0 5px"}
}
const _hoisted_28 = {
  key: 0,
  class: "link-editor"
}
const _hoisted_29 = {
  key: 1,
  class: "link-editor"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = {
  key: 0,
  class: "delivery-notice notice warn"
}
const _hoisted_32 = {
  key: 0,
  class: "item-dimensions",
  style: {"display":"flex"}
}
const _hoisted_33 = {
  key: 2,
  class: "wide-title"
}
const _hoisted_34 = { class: "highlight" }
const _hoisted_35 = { class: "item-meta" }
const _hoisted_36 = { class: "item-supplier-meta" }
const _hoisted_37 = { class: "description" }
const _hoisted_38 = { class: "description--overflow-wrapper" }
const _hoisted_39 = {
  key: 0,
  class: "data-table item-price-list--container"
}
const _hoisted_40 = { class: "item-price-list--item" }
const _hoisted_41 = { class: "item-price-list--item-label" }
const _hoisted_42 = { class: "item-price-list--item-quantity" }
const _hoisted_43 = { class: "item-price-list--item-value" }
const _hoisted_44 = {
  key: 1,
  class: "item-price-list--placeholder placeholder"
}
const _hoisted_45 = { class: "row scannable--container" }
const _hoisted_46 = {
  key: 1,
  class: "catalogue-product-list--container"
}
const _hoisted_47 = { class: "placeholder" }
const _hoisted_48 = {
  key: 2,
  class: "catalogue-product-list--container"
}
const _hoisted_49 = { class: "placeholder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entry_search = _resolveComponent("entry-search")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_OznButton = _resolveComponent("OznButton")!
  const _component_status_indicator = _resolveComponent("status-indicator")!
  const _component_scaling_image = _resolveComponent("scaling-image")!
  const _component_simple_link = _resolveComponent("simple-link")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_toggle = _resolveComponent("toggle")!
  const _component_tab_nav = _resolveComponent("tab-nav")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_entry_item = _resolveComponent("entry-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_entry_search, {
      show: _ctx.search.show,
      key: _ctx.search.show,
      "content-type": _ctx.linkType,
      payload: _ctx.filteredProducts,
      model: _ctx.productModel,
      onSelection: _cache[0] || (_cache[0] = s => {s.selection.forEach(_ctx.select); _ctx.handleSelectionCommit(); _ctx.search.show = false}),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search.show = false)),
      style: {"min-width":"320px","z-index":"9999"}
    }, {
      "search-item-content": _withCtx(({item}) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(item.sku || ''), 1)
      ]),
      _: 1
    }, 8, ["show", "content-type", "payload", "model"])),
    (_ctx.filteredCatalogueProducts && Array.isArray(_ctx.filteredCatalogueProducts))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("h4", {
                class: "bold section-header",
                style: {"margin-bottom":"0"}
              }, _toDisplayString(_ctx.label), 513), [
                [_vShow, _ctx.label]
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.filteredCatalogueProducts.length) + " items", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_form_input, {
                class: "small",
                "model-value": _ctx.productQuery,
                label: "Search",
                "onUpdate:modelValue": _ctx.setQuery
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "minimal",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
              }, "+ Add items")
            ]),
            (_ctx.removalQueue.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("u", _hoisted_9, _toDisplayString(_ctx.removalQueue.length) + " item" + _toDisplayString(_ctx.removalQueue.length===1 ? "" : "s") + " marked for removal", 1),
                  _createVNode(_component_OznButton, {
                    class: "minimal",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitSave()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("- delete item" + _toDisplayString(_ctx.removalQueue.length===1 ? "" : "s"), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("i", _hoisted_11, _toDisplayString(_ctx.message), 1)
            ])
          ]),
          (!_ctx.filteredCatalogueProducts || !_ctx.filteredCatalogueProducts.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "This catalogue has no products yet.", -1)),
                _createElementVNode("button", {
                  class: "minimal",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
                }, "Add some")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCatalogueProducts, (item, i) => {
                  return (_openBlock(), _createBlock(_component_entry_item, {
                    class: _normalizeClass(["ozn-entry-list__list-item expandable", {active: _ctx.expanded.includes(item.sys.id), danger: _ctx.removalQueue.includes(item.sys.id)}]),
                    entry: item,
                    size: "medium",
                    onClick: _withModifiers(e => !_ctx.expanded.includes(item.sys.id) && _ctx.expandItem(item, e), ["stop"]),
                    highlight: _ctx.expanded.includes(item.sys.id),
                    key: item.sys.id
                  }, {
                    header: _withCtx(({actions}) => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                          class: "minimal danger button-product-remove",
                          onClick: _withModifiers(($event: any) => (_ctx.toggleRemoval(item)), ["stop"]),
                          "data-cy": "product-remove-btn"
                        }, _toDisplayString(_ctx.removalQueue.includes(item.sys.id) ? 'Cancel removal' : 'Remove'), 9, _hoisted_15),
                        _createVNode(_component_status_indicator, {
                          class: "product-status",
                          type: !item.id || _ctx.checkDeliveryThreshold(item) ? 'warn' : item.active ? 'success' : 'disabled',
                          tooltip: !item.id ? `Item is not Linked to a Stock item ${item.active ? '' : '& not active'}` : item.active ? 'Item Active' : 'Not Active'
                        }, null, 8, ["type", "tooltip"]),
                        _createElementVNode("div", {
                          class: "expand-button product-expand-icon",
                          onClick: _withModifiers(($event: any) => (_ctx.expandItem(item, _ctx.e)), ["stop"])
                        }, [
                          _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
                            [_vShow, _ctx.expanded.includes(item.sys.id)]
                          ]),
                          _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                            [_vShow, !_ctx.expanded.includes(item.sys.id)]
                          ])
                        ], 8, _hoisted_16),
                        (item.images || _ctx.products.find(p => p.sys.id === item.id)?.images)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_scaling_image, {
                                src: item.images ? item.images[0] : _ctx.products.find(p => p.sys.id === item.id)?.images[0],
                                alt: item.title,
                                "show-zoom": ""
                              }, null, 8, ["src", "alt"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          _renderSlot(_ctx.$slots, "item-details", {
                            item: item,
                            expanded: _ctx.expanded,
                            removalQueue: _ctx.removalQueue,
                            products: _ctx.products
                          }, () => [
                            _renderSlot(_ctx.$slots, "item-header", {
                              item: item,
                              expanded: _ctx.expanded,
                              removalQueue: _ctx.removalQueue,
                              products: _ctx.products
                            }, () => [
                              _createElementVNode("div", _hoisted_21, [
                                (item.id)
                                  ? (_openBlock(), _createBlock(_component_simple_link, {
                                      key: 0,
                                      id: item.id,
                                      displayField: "ean",
                                      store: _ctx.products,
                                      onResolve: _ctx.updateProductStore,
                                      style: {"padding":"0","display":"block","width":"100%"}
                                    }, {
                                      default: _withCtx(({resolved, value}) => [
                                        _createElementVNode("span", null, "EAN " + _toDisplayString(Array.isArray(value) ? value.join(', ') : value), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "store", "onResolve"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, "Supplier item is not linked to a Stock Item")),
                                _createElementVNode("h6", {
                                  class: _normalizeClass(["product-title bold", {highlight: item.active, disabled: !item.active}])
                                }, _toDisplayString(item.title || _ctx.products.find(p => p.sys.id === item.id)?.title || '...'), 3),
                                (_ctx.expanded.includes(item.sys.id))
                                  ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                      key: 2,
                                      modelValue: item.title,
                                      "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                                      "auto-save": ""
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_q_input, {
                                          modelValue: scope.value,
                                          "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                          dense: "",
                                          autofocus: "",
                                          counter: "",
                                          onKeyup: _withKeys(scope.set, ["enter"])
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("span", _hoisted_24, _toDisplayString(item.price_list?.length || 0) + " " + _toDisplayString(item.price_list?.length > 1 ? 'prices' : 'price'), 1)
                              ])
                            ], true)
                          ], true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_ctx.expanded.includes(item.sys.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  (item.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _createVNode(_component_simple_link, {
                                          id: item.id,
                                          displayField: "title",
                                          pre: "Linked to item",
                                          store: _ctx.products,
                                          onResolve: _ctx.updateProductStore
                                        }, null, 8, ["id", "store", "onResolve"]),
                                        _createVNode(_component_ozn_button, {
                                          class: "minimal inline",
                                          onClick: ($event: any) => (_ctx.editItemLink(item))
                                        }, {
                                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode("Edit")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createVNode(_component_ozn_button, {
                                          class: "minimal inline",
                                          onClick: ($event: any) => (_ctx.editItemLink(item))
                                        }, {
                                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode("Link to Stock Item")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ])),
                                  _createVNode(_component_toggle, {
                                    modelValue: item.active,
                                    "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
                                    label: item.active ? 'active' : 'inactive',
                                    style: {"padding":"0","margin":"0"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  (_openBlock(), _createBlock(_component_tab_nav, {
                                    active: _ctx.tabState[item.sys?.id || item.id],
                                    "onUpdate:active": ($event: any) => ((_ctx.tabState[item.sys?.id || item.id]) = $event),
                                    views: _ctx.tabs,
                                    key: _ctx.tabState[item.sys?.id || item.id]?.id
                                  }, {
                                    details: _withCtx(({index, view, active}) => [
                                      _renderSlot(_ctx.$slots, "item-tab-details", {
                                        tab: {index, view, active},
                                        item: item,
                                        expanded: _ctx.expanded,
                                        products: _ctx.products
                                      }, () => [
                                        (_ctx.checkDeliveryThreshold(item))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                              _cache[10] || (_cache[10] = _createElementVNode("b", { class: "warn dark" }, "Available", -1)),
                                              _cache[11] || (_cache[11] = _createElementVNode("b", null, "Deliverable until", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.format.date(item.deliverable_to, _ctx.dateFormat)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.id)
                                          ? (_openBlock(), _createBlock(_component_simple_link, {
                                              key: 1,
                                              id: item.id,
                                              displayField: "dimensions",
                                              store: _ctx.products,
                                              onResolve: _ctx.updateProductStore
                                            }, {
                                              default: _withCtx(({resolved, value}) => [
                                                value
                                                  ? (_openBlock(), _createElementBlock("dl", _hoisted_32, [
                                                      _cache[12] || (_cache[12] = _createElementVNode("dt", null, "Width", -1)),
                                                      _createElementVNode("dd", null, _toDisplayString(value.width), 1),
                                                      _cache[13] || (_cache[13] = _createElementVNode("dt", null, "Height", -1)),
                                                      _createElementVNode("dd", null, _toDisplayString(value.height), 1),
                                                      _cache[14] || (_cache[14] = _createElementVNode("dt", null, "Depth", -1)),
                                                      _createElementVNode("dd", null, _toDisplayString(value.depth), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["id", "store", "onResolve"]))
                                          : _createCommentVNode("", true),
                                        (item.supplier_product_id)
                                          ? (_openBlock(), _createElementBlock("dl", _hoisted_33, [
                                              _cache[15] || (_cache[15] = _createElementVNode("dd", { class: "bold highlight" }, "Supplier product ID", -1)),
                                              _createElementVNode("dt", _hoisted_34, _toDisplayString(item.supplier_product_id), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.id)
                                          ? (_openBlock(), _createBlock(_component_simple_link, {
                                              key: 3,
                                              id: item.id,
                                              displayField: "meta",
                                              store: _ctx.products,
                                              onResolve: _ctx.updateProductStore,
                                              "empty-text": " "
                                            }, {
                                              default: _withCtx(({resolved, value}) => [
                                                value
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(value, (metaValue, key) => {
                                                      return (_openBlock(), _createElementBlock("dl", _hoisted_35, [
                                                        _createElementVNode("dt", null, _toDisplayString(_ctx.format.title(key)), 1),
                                                        _createElementVNode("dd", null, _toDisplayString(metaValue), 1)
                                                      ]))
                                                    }), 256))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["id", "store", "onResolve"]))
                                          : _createCommentVNode("", true),
                                        (item.meta)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(item.meta, (metaValue, key) => {
                                              return (_openBlock(), _createElementBlock("dl", _hoisted_36, [
                                                _createElementVNode("dt", null, _toDisplayString(_ctx.format.title(key)), 1),
                                                _createElementVNode("dd", null, _toDisplayString(metaValue), 1)
                                              ]))
                                            }), 256))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_37, [
                                          (item.id)
                                            ? (_openBlock(), _createBlock(_component_simple_link, {
                                                key: 0,
                                                id: item.id,
                                                displayField: "description",
                                                store: _ctx.products,
                                                onResolve: _ctx.updateProductStore
                                              }, {
                                                default: _withCtx(({resolved, value}) => [
                                                  _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "bold" }, "Description", -1)),
                                                  _createElementVNode("p", _hoisted_38, _toDisplayString(value), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["id", "store", "onResolve"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], true)
                                    ]),
                                    prices: _withCtx(({index, view, active}) => [
                                      _renderSlot(_ctx.$slots, "item-tab-prices", {
                                        tab: {index, view, active},
                                        item: item,
                                        expanded: _ctx.expanded,
                                        products: _ctx.products
                                      }, () => [
                                        (item.price_list)
                                          ? (_openBlock(), _createElementBlock("table", _hoisted_39, [
                                              _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                  _createElementVNode("th", { style: {"width":"100px"} }, "Label"),
                                                  _createElementVNode("th", null, "Quantity"),
                                                  _createElementVNode("th", null, "Price")
                                                ])
                                              ], -1)),
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.price_list, (price, index) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                                    _createElementVNode("td", _hoisted_41, [
                                                      _createVNode(_component_form_input, {
                                                        class: "mini",
                                                        modelValue: item.price_list[index].label,
                                                        "onUpdate:modelValue": ($event: any) => ((item.price_list[index].label) = $event)
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _createElementVNode("td", _hoisted_42, [
                                                      _createVNode(_component_form_input, {
                                                        class: "mini",
                                                        modelValue: item.price_list[index].quantity,
                                                        "onUpdate:modelValue": ($event: any) => ((item.price_list[index].quantity) = $event),
                                                        type: "number"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _createElementVNode("td", _hoisted_43, [
                                                      _createVNode(_component_form_input, {
                                                        class: "mini",
                                                        modelValue: item.price_list[index].value,
                                                        "onUpdate:modelValue": ($event: any) => ((item.price_list[index].value) = $event),
                                                        type: "currency",
                                                        "data-currency": "€"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[18] || (_cache[18] = [
                                              _createElementVNode("span", null, "This item has no prices set", -1)
                                            ]))),
                                        _createVNode(_component_ozn_button, {
                                          class: "minimal flat",
                                          onClick: ($event: any) => (_ctx.addItemPrice(item))
                                        }, {
                                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                                            _createTextVNode("+ Price")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        (item.sys?.editing)
                                          ? (_openBlock(), _createBlock(_component_ozn_button, {
                                              key: 2,
                                              class: "minimal flat",
                                              onClick: ($event: any) => (_ctx.updateItemPriceList(item))
                                            }, {
                                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                _createTextVNode("Save changes")
                                              ])),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ], true)
                                    ]),
                                    _: 2
                                  }, 1032, ["active", "onUpdate:active", "views"]))
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  (item.id)
                                    ? (_openBlock(), _createBlock(_component_simple_link, {
                                        key: 0,
                                        id: item.id,
                                        displayField: "ean",
                                        store: _ctx.products,
                                        onResolve: _ctx.updateProductStore,
                                        style: {"margin":"0 auto"}
                                      }, {
                                        default: _withCtx(({value, resolved}) => [
                                          (resolved?.ean && resolved?.ean[0] && [2,5,8,13,14].includes(resolved?.ean[0].length))
                                            ? (_openBlock(), _createBlock(_component_barcode, {
                                                key: 0,
                                                modelValue: resolved.ean[0],
                                                "onUpdate:modelValue": ($event: any) => ((resolved.ean[0]) = $event),
                                                format: "ean",
                                                "bar-width": 50,
                                                "bar-height": 5
                                              }, {
                                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                  _createElementVNode("div", { class: "placeholder" }, "...", -1)
                                                ])),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "store", "onResolve"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["entry", "onClick", "highlight", "class"]))
                }), 128))
              ]))
        ]))
      : (!_ctx.diffState.rhs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _cache[22] || (_cache[22] = _createElementVNode("span", null, "The product list seems to have loaded incorrectly.", -1)),
              _createElementVNode("button", {
                class: "minimal",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.reloadPage && _ctx.reloadPage(...args)))
              }, "Try refreshing the page")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _cache[23] || (_cache[23] = _createElementVNode("span", null, "Something seems to have gone wrong while loading this catalogues product list.", -1)),
              _createElementVNode("button", {
                class: "minimal",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.reloadPage && _ctx.reloadPage(...args)))
              }, "Try refreshing the page")
            ])
          ]))
  ], 64))
}